// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/index.styl
// module id = 891
// module chunks = 0